module.exports = __webpack_public_path__ + "img/nl.9f1b58d1.jpg";